import { z } from 'zod'

export const ADMINDESKTOPAGENTSDELETE_CONTRACT_VERSION = '1.0.0' as const
export const adminDesktopAgentsDeleteResponseSchema = z.unknown()
export type AdminDesktopAgentsDeleteResponse = z.infer<typeof adminDesktopAgentsDeleteResponseSchema>
